// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/laravel-mix/node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/laravel-mix/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "label[data-v-2d670baa]{font-weight:600;margin-bottom:0}", "",{"version":3,"sources":["webpack://./resources/js/components/dashboard/Account.vue"],"names":[],"mappings":"AACA,uBAEI,eAAA,CADA,eACJ","sourcesContent":["\nlabel {\n    margin-bottom: 0;\n    font-weight: 600;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
